export const setInitialInstituteId = (instituteId) => {
    if (instituteId) {
        localStorage.setItem('frmInitialInstituteId', instituteId);
    } else {
        localStorage.removeItem('frmInitialInstituteId');
    }
};

export const getInitialInstituteId = () => localStorage.getItem('frmInitialInstituteId') || null;
